export const INDEPENDANT_VIEW = -5679;